import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Dashboard from "./pages/Dashboard";
import Students from "./pages/Students";
import AddStudent from "./pages/AddStudent";
import Fees from "./pages/Fees";
import Reports from "./pages/Reports";
import Login from "./pages/Login";
import FeeStructure from "./pages/FeeStructure";
import Conveyance from "./pages/Conveyance";
import StudentProfile from "./pages/StudentProfile";
//import Defaulters from "./pages/Defaulters";
import Receipts from "./pages/Receipts";
import { useEffect } from "react";
import Users from "./pages/Users";



function App() {

  useEffect(() => {
    const checkExpiry = () => {
      const expiry = localStorage.getItem("expiry");

      if (!expiry) return;

      if (Date.now() > Number(expiry)) {
        localStorage.clear();
        window.location.href = "/login";
      }
    };

    checkExpiry();

    const interval = setInterval(checkExpiry, 60000); // every 1 min

    return () => clearInterval(interval);
  }, []);

  const [students, setStudents] = useState([
    {
      AdmNo: 1001,
      Name: "Vivaan Sharma",
      FatherName: "Aarav Bansal",
      Class: "One",
      Section: "D",
      Phone: "9676762622",
      RouteNo: 1
    }
  ]);

  const [payments, setPayments] = useState([]);
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  let permissions = [];

  if (token) {
    try {
      const decoded = JSON.parse(atob(token.split(".")[1]));
      permissions = decoded.permissions || [];
    } catch (e) {
      permissions = [];
    }
  }

  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("loggedIn") === "true"
  );

  return (
    <BrowserRouter>


      {isLoggedIn && <Navbar setIsLoggedIn={setIsLoggedIn} />}

      <div style={{
        padding: "20px",
        maxWidth: "1200px",
        margin: "auto",
        background: "#f4f6f9",
        minHeight: "100vh"
      }}>

        <Routes>
          <Route
            path="/"
            element={
              isLoggedIn ?
                <Dashboard students={students} payments={payments} />
                :
                <Navigate to="/login" />
            }
          />
          <Route
            path="/students"
            element={isLoggedIn ? <Students students={students} /> : <Navigate to="/login" />}
          />
          <Route
            path="/add-student"
            element={
              isLoggedIn
                ? <AddStudent students={students} setStudents={setStudents} />
                : <Navigate to="/login" />
            }
          />

          <Route
            path="/fees"
            element={
              isLoggedIn
                ? <Fees students={students} payments={payments} setPayments={setPayments} />
                : <Navigate to="/login" />
            }
          />



          <Route
            path="/reports"
            element={
              isLoggedIn && permissions.includes("VIEW_REPORTS")
                ? <Reports students={students} payments={payments} />
                : <Navigate to="/" />
            }
          />

          <Route
            path="/fee-structure"
            element={isLoggedIn ? <FeeStructure /> : <Navigate to="/login" />}
          />


          <Route
            path="/conveyance"
            element={isLoggedIn ? <Conveyance /> : <Navigate to="/login" />}
          />



          <Route
            path="/student/:admNo"
            element={isLoggedIn ? <StudentProfile /> : <Navigate to="/login" />}
          />



          <Route
            path="/receipts"
            element={isLoggedIn ? <Receipts /> : <Navigate to="/login" />}
          />

          <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />

          <Route
            path="/users"
            element={
              isLoggedIn && permissions.includes("MANAGE_USERS")
                ? <Users />
                : <Navigate to="/" />
            }
          />

        </Routes>
      </div>

    </BrowserRouter>
  );
}

export default App;